exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#ng-loading-overlay{background:hsla(0,0%,100%,.5)!important}#ng-hide-remove.ng-hide-remove,#ng-loading-overlay.ng-show{display:block!important}#ng-loading-overlay.ng-hide{opacity:0}#ng-loading-overlay.ng-hide-add,#ng-loading-overlay.ng-hide-remove{transition:all .4s linear}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/assets/overlay.css
// module id = 1597
// module chunks = 0